import React from "react";
import DynamicForm from "../../components/DynamicForm/DynamicForm";
import { getStoredData } from "../../json/fecthData";

const ProjectManagementCreate = () => {
  // Fetch stored project data
  const projectData = getStoredData()?.[1] || {}; // Ensure projectData is an object


  return (
    <div>
      <h2>Create New {projectData.TitleProject}</h2>
      <DynamicForm
        fields={projectData.AdminProject} // Pass dynamic fields
        apiUrl={projectData.ApiProjectRegister} // Use correct API URL
        successRedirect={projectData.RedirectAdminProject} // Redirect after successful submission
      />
    </div>
  );
};

export default ProjectManagementCreate;
